export const STATUS_LABELS = {
  execute_queries_to_kb: 'Выполняю запросы к БЗ',
  searching_kb: 'Ищу в базе знаний',
  analyzing_info: 'Анализирую информацию',
  forming_analysis: 'Формирую анализ',
  forming_questions: 'Формирую вопросы',
  forming_answer: 'Формирую ответ',
} as const;

export const START_EVENTS = new Set(['start', 'assistant_start', 'analysis_start']);
export const TOOL_CALL_EVENTS = new Set(['tool_call', 'analysis_tool_call']);
export const TOOL_CALL_RESULT_EVENTS = new Set(['tool_call_result', 'analysis_tool_call_result']);
export const INFORMATION_SOURCES_EVENTS = new Set(['information_sources']);
export const TOKEN_EVENTS = new Set(['token', 'analysis_token']);
export const COMPLETE_EVENTS = new Set(['complete', 'assistant_complete', 'analysis_complete']);
export const DONE_EVENTS = new Set(['done', 'analysis_done']);
export const ERROR_EVENTS = new Set(['error', 'analysis_error']);
